
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_yodkx_1r3w6_6"
};
  